export const displayInstallationLegendIphoneSelector = ({displayInstallationLegendIphone}) => displayInstallationLegendIphone